// Workspace breadcrumb: All documents › Folder › Subfolder. Each crumb links to
// its folder route; the last (current) crumb is plain text.

import { Link } from "react-router-dom";
import { Icon } from "./Icon";

export interface Crumb {
  id: string | null; // null = root
  name: string;
}

export function Breadcrumb({ trail }: { trail: Crumb[] }) {
  return (
    <nav className="breadcrumb" aria-label="Breadcrumb">
      {trail.map((c, i) => {
        const last = i === trail.length - 1;
        return (
          <span key={c.id ?? "root"} className="breadcrumb-item">
            {i > 0 && (
              <Icon name="chevron-right" size={14} className="breadcrumb-sep" />
            )}
            {last ? (
              <span className="breadcrumb-current" aria-current="page">
                {c.name}
              </span>
            ) : (
              <Link to={c.id ? `/folder/${c.id}` : "/"} className="breadcrumb-link">
                {c.name}
              </Link>
            )}
          </span>
        );
      })}
    </nav>
  );
}
